import { createSlice } from '@reduxjs/toolkit';
import { baseOnboardingUrl } from './hooks';

const initialState = {
  // Modal-specific state
  baseUrl: baseOnboardingUrl,
  
  // Stage checklist data
  stageCheckList: {
    "messaging": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "smsNumber is set in db"
    },
    "voice-profile": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "voice profile is set"
    },
    "messaging-profile": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "messaging profile is set"
    },
    "messaging-campaign": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "smsNumber number added to telnyx campaign"
    },
    "fax-profile": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "fax profile is set"
    },
    "fax-ui-hardcoded": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "fax ui is hardcoded"
    },
    "recall": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "Recall scheduler is hardcoded"
    },
    "recall-appointment": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "Recall appointment is set in db"
    },
    "confirmations": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "Confirmations scheduler is hardcoded"
    },
    "reviews": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "Reviews scheduler is hardcoded"
    },
    "auto-attendant": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "Auto-attendant is live if requested"
    },
    "practice-variables": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "bLiveInProd, bOnboardingInProgress, "
    },
    "intercom": {
      "workflows": ["voip", "dso"],
      "description": "intercom is set in vodia"
    }
  },
  
  // Loading and error states
  loading: false,
  error: null,
  
  // Success state
  success: false
};

const goLiveSlice = createSlice({
  name: 'goLive',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  clearError,
  clearSuccess,
  setLoading
} = goLiveSlice.actions;

// Selectors
export const selectBaseUrl = (state) => state.goLive.baseUrl;
export const selectStageCheckList = (state) => state.goLive.stageCheckList;
export const selectLoading = (state) => state.goLive.loading;
export const selectError = (state) => state.goLive.error;
export const selectSuccess = (state) => state.goLive.success;

export default goLiveSlice.reducer;
